// extracted by mini-css-extract-plugin
module.exports = {"iconUser":"userLogin_iconUser__3J6B1","iconChangeLanguage":"userLogin_iconChangeLanguage__2D5QX"};